var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftCreditCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71053 0 0 6.71053 0 15C0 23.2895 6.71053 30 15 30C23.2895 30 30 23.2895 30 15C30 6.71053 23.2895 0 15 0ZM15 28.4211C7.57895 28.4211 1.57895 22.4211 1.57895 15C1.57895 7.57895 7.57895 1.57895 15 1.57895C22.4211 1.57895 28.4211 7.57895 28.4211 15C28.4211 22.4211 22.4211 28.4211 15 28.4211ZM24.0395 9.90789C23.7237 9.5921 23.25 9.5921 22.9342 9.90789L12.8684 20.0132L8.64474 15.7895C8.32895 15.4737 7.81579 15.4737 7.53947 15.7895C7.22368 16.1053 7.22368 16.6184 7.53947 16.8947L12.3158 21.6711C12.4737 21.8289 12.6711 21.9079 12.8684 21.9079C13.0658 21.9079 13.2632 21.8289 13.4211 21.6711L24.0395 11.0132C24.3553 10.6974 24.3553 10.2237 24.0395 9.90789Z",
    fill: "url(#paint0_linear_1044_4092)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1044_4092",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5CDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftCreditCheck);
export default __webpack_public_path__ + "static/media/Soft-Credit-Check.ab0689ca71fc0604325848c75e4cf12f.svg";
export { ForwardRef as ReactComponent };